package app.bloomey.web.modules.auth

import app.bloomey.web.core.data.UiState

object AuthContract {
    data class State(
        val loginState: UiState<Boolean> = UiState.Initial,
    )

    sealed interface Inputs {
        data class Login(val email: String, val password: String) : Inputs
        data object ClearState : Inputs
    }

    sealed interface Events {
    }
}
